import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { Mail, X, ArrowRight } from 'lucide-react';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';

function SuggestedCoursesPopupContent({ onDismiss, onHideForToday, onViewNow, unviewedCount }) {
  return (
    <div className="flex items-center justify-center p-4 h-full">
      {/* Backdrop - temporary dismiss only */}
      <div
        className="fixed inset-0 bg-black/50"
        onClick={onDismiss}
      />

      {/* Modal */}
      <div className="modal-panel relative bg-white dark:bg-gray-800 rounded-2xl shadow-xl dark:shadow-gray-900/50 max-w-md w-full p-6">
        {/* Close button */}
        <button
          onClick={onDismiss}
          className="absolute top-4 right-4 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          <X className="w-5 h-5 text-gray-400 dark:text-gray-500" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-[#589DD5]/10 flex items-center justify-center">
            <Mail className="w-8 h-8 text-[#589DD5]" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            New Course Suggestions!
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            You have {unviewedCount} new course recommendation{unviewedCount > 1 ? 's' : ''} from A ONE Institute.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={onViewNow}
            className="w-full py-3 px-4 bg-[#589DD5] text-white font-medium rounded-lg hover:bg-[#4a8bc4] transition-colors flex items-center justify-center gap-2"
          >
            View Now
            <ArrowRight className="w-4 h-4" />
          </button>
          <button
            onClick={onHideForToday}
            className="w-full py-3 px-4 text-gray-600 dark:text-gray-400 font-medium rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            Hide for Today
          </button>
        </div>
      </div>
    </div>
  );
}

export default function SuggestedCoursesPopup({ isOpen, onDismiss, onHideForToday, onViewNow, unviewedCount }) {
  const nodeRef = useRef(null);
  useBodyScrollLock(isOpen);

  return createPortal(
    <CSSTransition
      in={isOpen}
      timeout={200}
      classNames="modal-animate"
      unmountOnExit
      nodeRef={nodeRef}
    >
      <div ref={nodeRef} className="modal-animate" style={{ zIndex: 200 }}>
        <SuggestedCoursesPopupContent
          onDismiss={onDismiss}
          onHideForToday={onHideForToday}
          onViewNow={onViewNow}
          unviewedCount={unviewedCount}
        />
      </div>
    </CSSTransition>,
    document.body
  );
}
